// 前端统一域名/URL 配置（仅前端使用）
// 配置文件：src/config/frontend_config.json

/* eslint-disable global-require */
let cfg = {};
try {
  cfg = require('../config/frontend_config.json');
} catch (e) {
  cfg = {};
}

export const LOGIN_URL = cfg.LOGIN_URL || 'https://test.navi-sci.cn/';
export const QINIU_UPLOAD_URL =
  cfg.QINIU_UPLOAD_URL || 'https://upload-z2.qiniup.com';
export const QINIU_PUBLIC_BASE =
  cfg.QINIU_PUBLIC_BASE || 'https://pstatic.navi-sci.cn';
export const QINIU_TOKEN_API_URL =
  cfg.QINIU_TOKEN_API_URL ||
  'https://test.admin.navi-sci.cn/prod-api/equipment/uploadCenter/getActivityUploadGetToken';

export const SEM_NESTED_API_BASE = cfg.SEM_NESTED_API_BASE || '';

